import UserTableService from 'app/admin/user/service/UserTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import AddMeasurementTaskButton from 'app/admin/common/component/AddMeasurementTaskButton';
import AddMeasurementButton from 'app/admin/common/component/AddMeasurementButton';
import LabMeasurementReaderTableService from '../service/LabMeasurementReaderTableService';
import LabMeasurementReaderService from '../service/LabMeasurementReaderService';

const config = {
	key: 'labMeasurementReaderTable',
	topic: 'labMeasurementReader',
	service: LabMeasurementReaderTableService,
	editFormState: item => `/lab-measurement-reader/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	rowButtonList: [/*{ key: 'addPiMeasurementTaskManager', component: AddMeasurementTaskButton },*/ { key: 'addMeasurement', component: AddMeasurementButton, service: LabMeasurementReaderService }],
	columns: [
		{
			key: 'name'
		},
		{
			key: 'driver_type'
		},
		{
			key: 'server'
		},
		{
			key: 'database'
		},
		{
			key: 'location'
		}
	]
};

function LabMeasurementReaderTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('labMeasurementReaderTable', reducer('labMeasurementReaderTable'))(LabMeasurementReaderTable);
